import { makeStyles } from 'beam/dist/styles'
import Grid from 'beam/dist/Grid'
import Button from 'beam/dist/Button'
import { Icon } from 'beam/dist/Icon'
import TextField from 'beam/dist/TextField'
import PropTypes from 'prop-types'

const upArrowKeyID = 'ArrowUp'
const downArrowKeyID = 'ArrowDown'

const withStyles = makeStyles(() => ({
  buttonGroup: {
    marginLeft: -18,
    marginRight: 8,
    marginTop: 9,
    marginBottom: 0,
    width: 16,
    direction: 'rtl',
    overflow: 'hidden',
    borderRadius: '0px 4px 4px 0px',
  },
  counterButton: {
    justifyContent: 'right',
    maxWidth: 6,
    height: 18.5,
  },
  arrow: {
    justifyContent: 'right',
    paddingLeft: 24,
    margin: 0,
    marginRight: -6,
    pointerEvents: 'none',
  },
  numberSpinnerGrid: {
    paddingLeft: '10px',
  },
}))

const NumberSpinnerComponent = ({ name, error, helperText, value, onChange, max, min, dataTestId }) => {
  const classes = withStyles()

  const onIncrement = () => {
    if (value !== max) {
      onChange(value + 1)
    }
  }

  const onDecrement = () => {
    if (value !== min) {
      onChange(value - 1)
    }
  }

  const keyPressHandler = event => {
    if (event.key === upArrowKeyID) {
      onIncrement()
    } else if (event.key === downArrowKeyID) {
      onDecrement()
    }
  }

  const onValueChange = event => {
    onChange(isNaN(parseInt(event.target.value)) ? '' : parseInt(event.target.value))
  }

  return (
    <Grid container direction="row" className={classes.numberSpinnerGrid}>
      <TextField
        name={name}
        className={classes.textfield}
        error={error}
        helperText={helperText}
        value={value}
        data-testId={dataTestId}
        onChange={onValueChange}
        onKeyDown={keyPressHandler}
      />

      <Grid container
        direction="column"
        className={classes.buttonGroup}
      >
        <Button
          className={classes.counterButton}
          onClick={onIncrement}
        >
          <Icon size={12} className={classes.arrow}>ChevronUp</Icon>
        </Button >
        <Button
          className={classes.counterButton}
          onClick={onDecrement}
        >
          <Icon size={12} className={classes.arrow}>ChevronDown</Icon>
        </Button>
      </Grid>

    </Grid>
  )
}


NumberSpinnerComponent.propTypes = {
  name: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
  classes: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  dataTestId: PropTypes.string,
}

NumberSpinnerComponent.defaultProps = {
  error: false,
}


const NumberSpinner = NumberSpinnerComponent
export default NumberSpinner
